export {
  NewCarsOffers as default,
  getStaticProps,
} from '@cinch-nx/feature-new-cars-offers'
